import { history } from "helpers";

const status = ["Review Pending", "Product Packaged", "Payment Initiated"];

export const getAuthToken = () => {
  return localStorage.getItem("token");
};

export const logout = () => {
  localStorage.clear();
  history.push("/");
};

export const dateDifference = (startDate) => {
  let d1 = new Date(startDate);
  let d2 = new Date();
  let months = 0;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth();
  months += d2.getMonth();
  return months >= 3 ? true : false;
};

export const getDateFormat = (date) => {
  let d1 = new Date();
  let months = "";
  months = `${d1.getFullYear()}-${d1.getMonth()}-${d1.getDate()}`;
  return months;
};

export const getStatusColor = (productStatus, isDetail) => {
  if (productStatus == "Payment Complete") {
    return "green_status";
  } else if (productStatus == "Review Pending") {
    return "pending_status";
  } else if (status.includes(productStatus)) {
    return "orange_status";
  } else if (isDetail) {
    return "status";
  }
};

export const splitFileName = (url) => {
  return String(url).split("/")[5].substring(29);
};

export const fileType = (fileName) => {
  return String(fileName).split(".")[String(fileName).split(".").length - 1];
};

export const getRoleAction = (moduleName) => {
  let user = JSON.parse(localStorage.getItem("user"));

  const { accessible = [], userType } = user || {};

  // console.log(accessible, "paymentActions");

  const currentModule =
    accessible.filter((data) => data?.module === moduleName)[0] || {};

  const { operation } = currentModule || {};

  const isAdmin = userType === "admins";

  const isOperationAvailable = (operationType) =>
    isAdmin || operation?.includes(operationType);

  return { operation, isAdmin, isOperationAvailable };
};
